import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import { processGroceryData } from '../../utils/groceryProcessor';

Font.register({
  family: 'LXGW WenKai Mono TC',
  // family: "LXGW WenKai Mono TC", monospace;
  fonts: [
    {
      src: 'https://fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Regular.otf',
      fontWeight: 'normal',
    },
    {
      src: 'https://fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Bold.otf',
      fontWeight: 'bold',
    }
  ]
});

// Create styles with Chinese font support
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 30,
    fontFamily: 'LXGW WenKai Mono TC', // Use Chinese-compatible font
  },
  header: {
    marginBottom: 20,
    textAlign: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    fontFamily: 'LXGW WenKai Mono TC',
  },
  subtitle: {
    fontSize: 14,
    color: '#666666',
    marginBottom: 20,
    fontFamily: 'LXGW WenKai Mono TC',
  },
  section: {
    marginBottom: 15,
  },
  categoryTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#333333',
    borderBottom: '1px solid #CCCCCC',
    paddingBottom: 3,
    fontFamily: 'LXGW WenKai Mono TC',
  },
  itemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 3,
    paddingLeft: 10,
  },
  itemName: {
    fontSize: 12,
    flex: 1,
    fontFamily: 'LXGW WenKai Mono TC',
  },
  itemQuantity: {
    fontSize: 12,
    color: '#666666',
    width: 80,
    textAlign: 'right',
    fontFamily: 'LXGW WenKai Mono TC',
  },
  emptyState: {
    textAlign: 'center',
    fontSize: 14,
    color: '#666666',
    marginTop: 50,
    fontFamily: 'LXGW WenKai Mono TC',
  }
});

const GroceryList = ({ planData, weekRange }) => {
  const groceryData = processGroceryData(planData);
  console.log(groceryData);
  const categories = Object.keys(groceryData).sort();
  console.log(categories);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          {/* <Text style={styles.title}>购物清单</Text> */}
          <Text style={styles.title}>Grocery Shopping List</Text>
          <Text style={styles.subtitle}>
            周期 Week: {weekRange?.startOfWeek || 'N/A'} - {weekRange?.endOfWeek || 'N/A'}
          </Text>
        </View>

        {categories.length === 0 ? (
          <View style={styles.emptyState}>
            <Text>没有找到食材。</Text>
            <Text>请确保您的菜谱包含食材信息。</Text>
            <Text>No ingredients found in the meal plan.</Text>
            <Text>Make sure your dishes have recipes with ingredients.</Text>
          </View>
        ) : (
          categories.map((category) => (
            <View key={category} style={styles.section}>
              <Text style={styles.categoryTitle}>{category}</Text>
              {groceryData[category].map((ingredient, index) => (
                <View key={index} style={styles.itemRow}>
                  <Text style={styles.itemName}>• {ingredient.name}</Text>
                  <Text style={styles.itemQuantity}>{ingredient.quantity}</Text>
                </View>
              ))}
            </View>
          ))
        )}

        <View style={{ marginTop: 30, textAlign: 'center' }}>
          <Text style={{ fontSize: 10, color: '#999999', fontFamily: 'LXGW WenKai Mono TC' }}>
            生成时间 Generated on {new Date().toLocaleDateString()}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default GroceryList;